$(document).ready(function() { 
  
// CountDown Timer Starts
  if ($("#time").length > 0){
    var getValue = $("strong#time").text();
    console.log("Time =>", getValue);  
    var start = new Date;
    start.setHours(getValue, 0, 0); // 11pm
  
    const weekday = ["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"];
    let day = weekday[start.getDay()];
    console.log("Today =>", day);
  
    var numberOfDaysToAdd = 3;
    var result = start.setDate(start.getDate() + numberOfDaysToAdd);  
    var newResult = new Date(result);
    let newDay = weekday[newResult.getDay()];
    
    if(newDay == 'Samstag'){
      var saturdayResult = start.setDate(start.getDate() + 5);  
      var newwwResult = new Date(saturdayResult);
      var newwwDay = weekday[newwwResult.getDay()];
      console.log("If Saturday =>", newwwDay);
      $('.dataArea p i').text(newwwDay);
    }else if(newDay == 'Sonntag'){
      var saturdayResult = start.setDate(start.getDate() + 4);  
      var newwwResult = new Date(saturdayResult);
      var newwwDay = weekday[newwwResult.getDay()];
      console.log("If Sunday =>", newwwDay);
      $('.dataArea p i').text(newwwDay);
    }else{
      console.log("After 3 Days =>", newDay);
      $('.dataArea p i').text(newDay);
    }
    
    
  
    tick();  
  }
  function pad(num) {
    return ("0" + parseInt(num)).substr(-2);
  }

  function tick() {
    var now = new Date;
    if (now > start) { // too late, go to tomorrow
      start.setDate(start.getDate() + 1);
    }
    var remain = ((start - now) / 1000);
    var hh = pad((remain / 60 / 60) % 60);
    var mm = pad((remain / 60) % 60);
    var ss = pad(remain % 60);
    document.getElementById('time').innerHTML =
      hh + ":" + mm + ":" + ss;
    setTimeout(tick, 1000);
  }  
// CountDown Timer Ends

    $(document).on("click",".singleStrapProduct",function() {
      $(".singleStrapProduct").removeClass("active");
      $(this).addClass("active");

      let variant_id = $(this).attr("data-variant-id");
      console.log("Variant Id =>", variant_id);
      if (! $('input[name="items[]id"]').length) {
        $('<input>', {
          type: "hidden",
          name: "items[]id",
          value: variant_id
        }).appendTo('.shopify-product-form')
      }else{
        $("input[name='items[]id']").val(variant_id);
      }

      $(".removeAllStrapProduct").addClass("show");
     
    });

  $(document).on("click",".removeAllStrapProduct",function() {
    $(".singleStrapProduct").removeClass("active");
    $("input[name='items[]id']").remove();
    $(this).removeClass("show");
  });

  $(document).on("click",".removeBundlePart",function() {
    $(this).parents(".parentCartBundle").remove();
  });

  

});                  